import {useUpmPlant} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'
import {Outlet} from 'react-router'

import {useKilnNodesQuery} from '@refra/modules/common/hooks/queries'
import {KilnsProvider, useRefraModal} from '@refra/modules/common/providers'
import {RefraStaticPartsShutdownsWrapper} from '@refra/modules/refra-static-parts/RefraStaticPartsShutdownsWrapper'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const RefraStaticParts = () => {
  const {modal} = useRefraModal()

  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode})

  const {data: kilnNodes} = useKilnNodesQuery(upmPlant.upmId)

  if (!kilnNodes) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="xlarge" data-cy="refra_planning_loader" />
      </div>
    )
  }

  // Safety net for the plants without kilns,
  // even though the product should not be available for such plants
  if (kilnNodes.length === 0) return null

  return (
    <KilnsProvider kilnNodes={kilnNodes} shouldRedirectToUrlKiln={true}>
      <RefraStaticPartsShutdownsWrapper>
        <div className="px-6">
          <Outlet />
          {modal}
        </div>
      </RefraStaticPartsShutdownsWrapper>
    </KilnsProvider>
  )
}
